import React, { useState } from "react";
import {
  Grid,
  Typography,
  Button,
  Box,
  CardMedia,
  TextField,
  Container,
} from "@mui/material";
import PropTypes from "prop-types";
import { Link, useLocation, useSearchParams } from "react-router-dom";
import {
  FloatingMenu,
  MainButton,
  ChildButton,
  Directions,
} from "react-floating-button-menu";
import { ReactComponent as ChevronRight } from "../../Assets/images/chat.svg";
import { ReactComponent as Closeico } from "../../Assets/images/close.svg";

import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";

import CallIcon from "@mui/icons-material/Call";
import Tooltip from "@mui/material/Tooltip";
import SubFooter from "./SubFooter";
import FacebookIcon from "@mui/icons-material/Facebook";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import TwitterIcon from "@mui/icons-material/Twitter";
import InstagramIcon from "@mui/icons-material/Instagram";
import YouTubeIcon from "@mui/icons-material/YouTube";
import "./Footer.css";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import axios from "axios";
import Swal from "sweetalert2";
import CircularProgress from "@mui/material/CircularProgress";
import Backdrop from "@mui/material/Backdrop";
import Divider from "@mui/material/Divider";
import MenuItem from "@mui/material/MenuItem";
import FreshChat from "react-freshchat";
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
// import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Rcta from "../cta/request_a_call_back";
import AddIcon from '@mui/icons-material/Add';

const Footer = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const [program, setProgram] = useState("---- Select Program ----");
  const [Rcbopen, RcbsetOpen] = useState(false);
  const handleChange = (event) => {
    setProgram(event.target.value);
  };
  const [cta, setCta] = useState(false);
  const handleClickOpenRcb = () => {
    setCta(true);
  };
  const RcbhandleClose = () => {
    setCta(false);
  };
  

  const [open, setOpen] = useState(false);
  // const [isFreshchatOpen, setisFreshchatOpen] = useState(false);
  // //console.log(isFreshchatOpen,"freshchat")
  const LoaderClose = () => {
    setOpen(false);
  };
  const LoaderOpen = () => {
    setOpen(true);
  };

  const handleFreshchatButtonClick = () => {
    window.fcWidget.open();
  };
  return (
    <>
      <Box className="footer" sx={{ display: { xs: "none", lg: "block" } }}>
        <Container fixed>
          <Grid container item lg={12} sx={{ marginBottom: "2rem" }}>
            <Grid
              item
              lg={8}
              xs={8}
              md={8}
              sx={{ display: "flex", flexDirection: "column" }}
            >
              <img
                style={{ width: "9rem" }}
                src="	https://storage.googleapis.com/accredian-assets/Frontend_Assests/Images/Accredian-react-site-images/logo/accredainnew.webp"
                alt=""
              />
              {/* <span className="img-head">
              International School of AI & Data Science
            </span> */}
            </Grid>
            <Grid
              item
              lg={4}
              xs={4}
              md={4}
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <Button
                sx={{
                  backgroundColor: "#007bff",
                  color: "#fff",
                  border: "1px solid #fff",
                  borderRadius: "8px",
                  textTransform: "none",
                  width: "250px",
                  "&:hover": {
                    backgroundColor: "#007bff",
                    color: "#fff",
                    border: "1px solid #fff",
                    borderRadius: "8px",
                  },
                }}
                onClick={handleClickOpenRcb}
              >
                Schedule 1-on-1 Call Now
              </Button>
              <span className="footer-head-right-text">
                Speak with our Learning Advisor
              </span>
            </Grid>
          </Grid>
          <hr />
          <Grid container lg={12} className="footer-body">
            <Grid item lg={5} md={5} sx={{ mt: 4 }}>
              <Typography
                sx={{
                  color: "#fff",
                  textDecoration: "none",
                  marginBottom: "0.2rem!important",
                  fontSize: "20px",
                  ml: 2,
                }}
              >
                Programs
              </Typography>

              <Accordion sx={{
                backgroundColor: "transparent",
                boxShadow: "none",
                width: "380px",
                "&&:before": {
                  borderBottom: "none",
                  backgroundColor: "transparent",
                },
              }}>
                <AccordionSummary
                  expandIcon={<AddIcon sx={{ color: "#fff" }} />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  <Typography
                    sx={{
                      color: "#fff",
                      textDecoration: "none",
                      marginBottom: "0.2rem!important",
                      fontSize: "17px",
                      fontWeight: "bold",
                    }}
                  >
                    Data Science & AI
                  </Typography>
                </AccordionSummary>
                <AccordionDetails sx={{ p: 0, ml: 1 }}>
                  <ul className="footer-body-content">
                    <li>
                      <Link
                        to="/iit/executive-program-in-ds-and-ai-advance"
                        style={{ textDecoration: "none" }}
                      >
                        <Typography
                          sx={{
                            color: "#fff",
                            textDecoration: "none",
                            marginBottom: "0rem!important",
                            fontSize: "14px",
                          }}
                        >
                          E&ICT IIT G - Executive Program in Data Science & AI
                        </Typography>
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/iit/executive-program-in-ds-ba"
                        style={{ textDecoration: "none" }}
                      >
                        <Typography
                          sx={{
                            color: "#fff",
                            textDecoration: "none",
                            marginBottom: "0rem!important",
                            fontSize: "14px",
                          }}
                        >
                          E&ICT IIT G- Executive Program in Data Science and
                          Business Analytics
                        </Typography>
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/iit/executive-program-in-ds-and-dt"
                        style={{ textDecoration: "none" }}
                      >
                        <Typography
                          sx={{
                            color: "#fff",
                            textDecoration: "none",
                            marginBottom: "0rem!important",
                            fontSize: "14px",
                          }}
                        >
                          E&ICT IIT G - Executive Program in Data Science and Digital Transformation
                        </Typography>
                      </Link>
                    </li>
                    {/* <li>
                      <Link
                        to="/iit/executive-program-in-ml-and-ai"
                        style={{ textDecoration: "none" }}
                      >
                        <Typography
                          sx={{
                            color: "#fff",
                            textDecoration: "none",
                            marginBottom: "0rem!important",
                            fontSize: "14px",
                          }}
                        >
                          E&ICT IIT G - Executive Program in Machine Learning & Artificial intelligence
                        </Typography>
                      </Link>
                    </li> */}

                    <li>
                      <Link
                        to="/pgp-in-data-science-and-ai"
                        style={{ textDecoration: "none" }}
                      >
                        <Typography
                          sx={{
                            color: "#fff",
                            textDecoration: "none",
                            marginBottom: "0rem!important",
                            fontSize: "14px",
                          }}
                        >
                          Accredian - PGP in Data Science & AI
                        </Typography>
                      </Link>
                    </li>
                    {/* <li>
                      <Link
                        to="/pgp-in-ds-ba"
                        style={{ textDecoration: "none" }}
                      >
                        <Typography
                          sx={{
                            color: "#fff",
                            textDecoration: "none",
                            marginBottom: "0rem!important",
                            fontSize: "14px",
                          }}
                        >
                          Accredian - PGP in Data Science and Business Analytics
                        </Typography>
                      </Link>
                    </li> */}
                    {/* <li>
                      <Link
                        to="/pgp-in-ds-ba"
                        style={{ textDecoration: "none" }}
                      >
                        <Typography
                          sx={{
                            color: "#fff",
                            textDecoration: "none",
                            marginBottom: "0rem!important",
                            fontSize: "14px",
                          }}
                        >
                          Accredian - PGP in Data Science and Business Analytics
                        </Typography>
                      </Link>
                    </li> */}
                    <li>
                      <Link
                        to="/global-certificate-in-data-science-and-ai"
                        style={{ textDecoration: "none" }}
                      >
                        <Typography
                          sx={{
                            color: "#fff",
                            textDecoration: "none",
                            marginBottom: "0rem!important",
                            fontSize: "14px",
                          }}
                        >
                          Accredian - Global Certificate in Data Science & AI Program
                        </Typography>
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/pgp-in-machine-learning-and-ai"
                        style={{ textDecoration: "none" }}
                      >
                        <Typography
                          sx={{
                            color: "#fff",
                            textDecoration: "none",
                            marginBottom: "0rem!important",
                            fontSize: "14px",
                          }}
                        >
                          Accredian - PGP in Machine Learning & AI
                        </Typography>
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/pgp-in-ai"
                        style={{ textDecoration: "none" }}
                      >
                        <Typography
                          sx={{
                            color: "#fff",
                            textDecoration: "none",
                            marginBottom: "0rem!important",
                            fontSize: "14px",
                          }}
                        >
                          Accredian - PGP in Artificial intelligence
                        </Typography>
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/global-certificate-in-data-science"
                        style={{ textDecoration: "none" }}
                      >
                        <Typography
                          sx={{
                            color: "#fff",
                            textDecoration: "none",
                            marginBottom: "0rem!important",
                            fontSize: "14px",
                          }}
                        >
                          Accredian - Global Certificate in Data Science Program
                        </Typography>
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/certificate-in-data-science-foundation"
                        style={{ textDecoration: "none" }}
                      >
                        <Typography
                          sx={{
                            color: "#fff",
                            textDecoration: "none",
                            marginBottom: "0rem!important",
                            fontSize: "14px",
                          }}
                        >
                          Accredian - Certificate in Data Science Foundation Program
                        </Typography>
                      </Link>
                    </li>
                  </ul>
                </AccordionDetails>
              </Accordion>



              <Accordion sx={{
                backgroundColor: "transparent",
                boxShadow: "none",
                width: "380px",
                "&&:before": {
                  borderBottom: "none",
                  backgroundColor: "transparent",
                },
              }}>
                <AccordionSummary
                  expandIcon={<AddIcon sx={{ color: "#fff" }} />}
                  aria-controls="panel1as-content"
                  id="panel1as-header"
                >
                  <Typography
                    sx={{
                      color: "#fff",
                      textDecoration: "none",
                      marginBottom: "0.2rem!important",
                      fontSize: "17px",
                      fontWeight: "bold",
                    }}
                  >
                    Product Management
                  </Typography>
                </AccordionSummary>
                <AccordionDetails sx={{ p: 0, ml: 1 }}>
                  <ul className="footer-body-content">
                    <li>
                      <Link
                        to="/iit/executive-program-in-pmds"
                        style={{ textDecoration: "none" }}
                      >
                        <Typography
                          sx={{
                            color: "#fff",
                            textDecoration: "none",
                            marginBottom: "0rem!important",
                            fontSize: "14px",
                          }}
                        >
                          E&ICT IIT G - Executive Program in Product Management and Data Science
                        </Typography>
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/iit/executive-program-in-data-driven-product-management"
                        style={{ textDecoration: "none" }}
                      >
                        <Typography
                          sx={{
                            color: "#fff",
                            textDecoration: "none",
                            marginBottom: "0rem!important",
                            fontSize: "14px",
                          }}
                        >
                          E&ICT IIT G - Executive Program in Data Driven Product Management
                        </Typography>
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/iit/executive-program-in-pm"
                        style={{ textDecoration: "none" }}
                      >
                        <Typography
                          sx={{
                            color: "#fff",
                            textDecoration: "none",
                            marginBottom: "0rem!important",
                            fontSize: "14px",
                          }}
                        >
                          E&ICT IIT G - Executive Program in Product Management
                        </Typography>
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/iit/executive-program-in-pm"
                        style={{ textDecoration: "none" }}
                      >
                        <Typography
                          sx={{
                            color: "#fff",
                            textDecoration: "none",
                            marginBottom: "0rem!important",
                            fontSize: "14px",
                          }}
                        >
                          E&ICT IIT G - Executive Program in Product Management
                        </Typography>
                      </Link>
                    </li>
                    {/* <li>
                      <Link
                        to="/Xlri/executive-program-in-pm-by-xlri"
                        style={{ textDecoration: "none" }}
                      >
                        <Typography
                          sx={{
                            color: "#fff",
                            textDecoration: "none",
                            marginBottom: "0rem!important",
                            fontSize: "14px",
                          }}
                        >
                          XLRI - Executive Program in Product Management
                        </Typography>
                      </Link>
                    </li> */}
                    <li>
                      <Link
                        to="/iit/advanced-certification-in-pm"
                        style={{ textDecoration: "none" }}
                      >
                        <Typography
                          sx={{
                            color: "#fff",
                            textDecoration: "none",
                            marginBottom: "0rem!important",
                            fontSize: "14px",
                          }}
                        >
                          E&ICT IIT G - Advanced Certification in Product Management
                        </Typography>
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/iit/executive-program-in-pm-and-dt"
                        style={{ textDecoration: "none" }}
                      >
                        <Typography
                          sx={{
                            color: "#fff",
                            textDecoration: "none",
                            marginBottom: "0rem!important",
                            fontSize: "14px",
                          }}
                        >
                          E&ICT IIT G - Executive Program in Product Management and Digital Transformation
                        </Typography>
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/iit/executive-program-in-pm-ba"
                        style={{ textDecoration: "none" }}
                      >
                        <Typography
                          sx={{
                            color: "#fff",
                            textDecoration: "none",
                            marginBottom: "0rem!important",
                            fontSize: "14px",
                          }}
                        >
                          E&ICT IIT G - Executive Program in Product Management and Business Analytics
                        </Typography>
                      </Link>
                    </li>
                    
                    <li>
                      <Link
                        to="/iim/pg-certificate-program-in-strategic-product-management"
                        style={{ textDecoration: "none" }}
                      >
                        <Typography
                          sx={{
                            color: "#fff",
                            textDecoration: "none",
                            marginBottom: "0rem!important",
                            fontSize: "14px",
                          }}
                        >
                         IIMV - PG Certificate Program in Strategic Product Management
                        </Typography>
                      </Link>
                    </li>
                  </ul>
                </AccordionDetails>
              </Accordion>


              <Accordion sx={{
                backgroundColor: "transparent",
                boxShadow: "none",
                width: "380px",
                "&&:before": {
                  borderBottom: "none",
                  backgroundColor: "transparent",
                },
              }}>
                <AccordionSummary
                  expandIcon={<AddIcon sx={{ color: "#fff" }} />}
                  aria-controls="panel1asgm-content"
                  id="panel1asgm-header"
                >
                  <Typography
                    sx={{
                      color: "#fff",
                      textDecoration: "none",
                      marginBottom: "0.2rem!important",
                      fontSize: "17px",
                      fontWeight: "bold",
                    }}
                  >
                    General Management
                  </Typography>
                </AccordionSummary>
                <AccordionDetails sx={{ p: 0, ml: 1 }}>
                  <ul className="footer-body-content">
                    <li>
                      <Link
                        to="/XLRI/executive-program-in-general-management"
                        style={{ textDecoration: "none" }}
                      >
                        <Typography
                          sx={{
                            color: "#fff",
                            textDecoration: "none",
                            marginBottom: "0rem!important",
                            fontSize: "14px",
                          }}
                        >
                          XLRI- Executive Program in General Management
                        </Typography>
                      </Link>
                    </li>
                  </ul>
                </AccordionDetails>
              </Accordion>

              <Accordion sx={{
                backgroundColor: "transparent",
                boxShadow: "none",
                width: "380px",
                "&&:before": {
                  borderBottom: "none",
                  backgroundColor: "transparent",
                },
              }}>
                <AccordionSummary
                  expandIcon={<AddIcon sx={{ color: "#fff" }} />}
                  aria-controls="panel1asgm-content"
                  id="panel1asdt-header"
                >
                  <Typography
                    sx={{
                      color: "#fff",
                      textDecoration: "none",
                      marginBottom: "0.2rem!important",
                      fontSize: "17px",
                      fontWeight: "bold",
                    }}
                  >
                   Digital Transformation
                  </Typography>
                </AccordionSummary>
                <AccordionDetails sx={{ p: 0, ml: 1 }}>
                  <ul className="footer-body-content">
                    {/* <li>
                      <Link
                        to="/Xlri/executive-program-in-digital-transformation"
                        style={{ textDecoration: "none" }}
                      >
                        <Typography
                          sx={{
                            color: "#fff",
                            textDecoration: "none",
                            marginBottom: "0rem!important",
                            fontSize: "14px",
                          }}
                        >
                          XLRI- Executive Program in Digital Transformation
                        </Typography>
                      </Link>
                    </li> */}
                    <li>
                      <Link
                        to="/spj/executive-program-in-digital-transformation"
                        style={{ textDecoration: "none" }}
                      >
                        <Typography
                          sx={{
                            color: "#fff",
                            textDecoration: "none",
                            marginBottom: "0rem!important",
                            fontSize: "14px",
                          }}
                        >
                          SP Jain Global - Executive Program in Digital Leadership for Business Transformation
                        </Typography>
                      </Link>
                    </li>
                  </ul>
                </AccordionDetails>
              </Accordion>
              {/* <Accordion sx={{
                backgroundColor: "transparent",
                boxShadow: "none",
                width: "380px",
                "&&:before": {
                  borderBottom: "none",
                  backgroundColor: "transparent",
                },
              }}>
                <AccordionSummary
                  expandIcon={<AddIcon sx={{ color: "#fff" }} />}
                  aria-controls="panel1asgm-content"
                  id="panel1asosm-header"
                >
                  <Typography
                    sx={{
                      color: "#fff",
                      textDecoration: "none",
                      marginBottom: "0.2rem!important",
                      fontSize: "17px",
                      fontWeight: "bold",
                    }}
                  >
               Operations & Supply Chain Management
                  </Typography>
                </AccordionSummary>
                <AccordionDetails sx={{ p: 0, ml: 1 }}>
                  <ul className="footer-body-content">
                    <li>
                      <Link
                        to="/spj/executive-program-in-oscm"
                        style={{ textDecoration: "none" }}
                      >
                        <Typography
                          sx={{
                            color: "#fff",
                            textDecoration: "none",
                            marginBottom: "0rem!important",
                            fontSize: "14px",
                          }}
                        >
                          SP Jain Global- Executive Program in Operations & Supply Chain Management
                        </Typography>
                      </Link>
                    </li>
                  </ul>
                </AccordionDetails>
              </Accordion> */}
              <Accordion sx={{
                backgroundColor: "transparent",
                boxShadow: "none",
                width: "380px",
                "&&:before": {
                  borderBottom: "none",
                  backgroundColor: "transparent",
                },
              }}>
                <AccordionSummary
                  expandIcon={<AddIcon sx={{ color: "#fff" }} />}
                  aria-controls="panel1asgm-content"
                  id="panel1asosm-header"
                >
                  <Typography
                    sx={{
                      color: "#fff",
                      textDecoration: "none",
                      marginBottom: "0.2rem!important",
                      fontSize: "17px",
                      fontWeight: "bold",
                    }}
                  >
               Business Management
                  </Typography>
                </AccordionSummary>
                <AccordionDetails sx={{ p: 0, ml: 1 }}>
                  <ul className="footer-body-content">
                    <li>
                      <Link
                        to="/iim/executive-program-in-business-management"
                        style={{ textDecoration: "none" }}
                      >
                        <Typography
                          sx={{
                            color: "#fff",
                            textDecoration: "none",
                            marginBottom: "0rem!important",
                            fontSize: "14px",
                          }}
                        >
                          IIM Visakhapatnam - Executive Program in Business Management
                        </Typography>
                      </Link>
                    </li>
                  </ul>
                </AccordionDetails>
              </Accordion>
              <Accordion sx={{
                backgroundColor: "transparent",
                boxShadow: "none",
                width: "380px",
                "&&:before": {
                  borderBottom: "none",
                  backgroundColor: "transparent",
                },
              }}>
                <AccordionSummary
                  expandIcon={<AddIcon sx={{ color: "#fff" }} />}
                  aria-controls="panel1asgm-content"
                  id="panel1asosm-header"
                >
                  <Typography
                    sx={{
                      color: "#fff",
                      textDecoration: "none",
                      marginBottom: "0.2rem!important",
                      fontSize: "17px",
                      fontWeight: "bold",
                    }}
                  >
               Project Management
                  </Typography>
                </AccordionSummary>
                <AccordionDetails sx={{ p: 0, ml: 1 }}>
                  <ul className="footer-body-content">
                  <li>
                      <Link
                        to="/iit/executive-program-in-dspmi"
                        style={{ textDecoration: "none" }}
                      >
                        <Typography
                          sx={{
                            color: "#fff",
                            textDecoration: "none",
                            marginBottom: "0rem!important",
                            fontSize: "14px",
                          }}
                        >
                          E&ICT IIT G - Executive Program in Data Science and Project Management
                        </Typography>
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/iit/executive-program-in-pmpmi"
                        style={{ textDecoration: "none" }}
                      >
                        <Typography
                          sx={{
                            color: "#fff",
                            textDecoration: "none",
                            marginBottom: "0rem!important",
                            fontSize: "14px",
                          }}
                        >
                          E&ICT IIT G - Executive Program in Product Management and Project Management
                        </Typography>
                      </Link>
                    </li>
                  </ul>
                </AccordionDetails>
              </Accordion>
              <Accordion sx={{
                backgroundColor: "transparent",
                boxShadow: "none",
                width: "380px",
                "&&:before": {
                  borderBottom: "none",
                  backgroundColor: "transparent",
                },
              }}>
                <AccordionSummary
                  expandIcon={<AddIcon sx={{ color: "#fff" }} />}
                  aria-controls="panel1asgm-content"
                  id="panel1asgm-header"
                >
                  <Typography
                    sx={{
                      color: "#fff",
                      textDecoration: "none",
                      marginBottom: "0.2rem!important",
                      fontSize: "17px",
                      fontWeight: "bold",
                    }}
                  >
                    Strategy & Leadership
                  </Typography>
                </AccordionSummary>
                <AccordionDetails sx={{ p: 0, ml: 1 }}>
                  <ul className="footer-body-content">
                    <li>
                      <Link
                        to="/XLRI/executive-program-in-strategy-leadership"
                        style={{ textDecoration: "none" }}
                      >
                        <Typography
                          sx={{
                            color: "#fff",
                            textDecoration: "none",
                            marginBottom: "0rem!important",
                            fontSize: "14px",
                          }}
                        >
                          XLRI- Executive Program in Strategy & Leadership
                        </Typography>
                      </Link>
                    </li>
                  </ul>
                </AccordionDetails>
              </Accordion>
              {/* <Accordion sx={{
                backgroundColor: "transparent",
                boxShadow: "none",
                width: "380px",
                "&&:before": {
                  borderBottom: "none",
                  backgroundColor: "transparent",
                },
              }}>
                <AccordionSummary
                  expandIcon={<AddIcon sx={{ color: "#fff" }} />}
                  aria-controls="panel1asgm-content"
                  id="panel1ascs-header"
                >
                  <Typography
                    sx={{
                      color: "#fff",
                      textDecoration: "none",
                      marginBottom: "0.2rem!important",
                      fontSize: "17px",
                      fontWeight: "bold",
                    }}
                  >
             Cyber Security
                  </Typography>
                </AccordionSummary>
                <AccordionDetails sx={{ p: 0, ml: 1 }}>
                  <ul className="footer-body-content">
                    <li>
                      <Link
                        to="/Adani/executive-program-in-cyber-security"
                        style={{ textDecoration: "none" }}
                      >
                        <Typography
                          sx={{
                            color: "#fff",
                            textDecoration: "none",
                            marginBottom: "0rem!important",
                            fontSize: "14px",
                          }}
                        >
                          Adani- Executive Program in Cyber Security
                        </Typography>
                      </Link>
                    </li>
                  </ul>
                </AccordionDetails>
              </Accordion> */}

            </Grid>
            <Grid item lg={5} md={5} sx={{ mt: 4 }}>
              <div className="footer-body-head">
                <Typography
                  sx={{
                    color: "#fff",
                    textDecoration: "none",
                    marginBottom: "0.2rem!important",
                    fontSize: "20px",
                  }}
                >
                  Contact Us
                </Typography>

                <ul className="footer-body-content">
                  <li>
                    <Typography
                      sx={{
                        color: "#fff",
                        textDecoration: "none",
                        marginBottom: "0.2rem!important",
                        fontSize: "14px",
                      }}
                    >
                      <a href="mailto:admissions@accredian.com" style={{ textDecoration: "none", color: "#fff" }}> Email us (For Data Science Queries): admissions@accredian.com</a>
                    </Typography>
                  </li>

                  <li>
                    <Typography
                      sx={{
                        color: "#fff",
                        textDecoration: "none",
                        marginBottom: "0.2rem!important",
                        fontSize: "14px",
                      }}
                    >
                      <a href="mailto:pm@accredian.com" style={{ textDecoration: "none", color: "#fff" }}>Email us (For Product Management Queries):pm@accredian.com</a>
                    </Typography>
                  </li>
                  <li>
                    <Typography
                      sx={{
                        color: "#fff",
                        textDecoration: "none",
                        marginBottom: "0.2rem!important",
                        fontSize: "14px",
                      }}
                    >
                      {" "}
                      <a href="tel:+919079653292" style={{ textDecoration: "none", color: "#fff" }}> Data Science Admission Helpline:+91 9079653292 (9 AM - 7
                        PM)</a>
                    </Typography>
                  </li>

                  <li>
                    <Typography
                      sx={{
                        color: "#fff",
                        textDecoration: "none",
                        marginBottom: "0.2rem!important",
                        fontSize: "14px",
                      }}
                    >
                      {" "}
                      <a href="tel:+919625811095" style={{ textDecoration: "none", color: "#fff" }}> Product Management Admission Helpline:+91 9625811095</a>
                    </Typography>
                  </li>
                  <li>
                    <Typography
                      sx={{
                        color: "#fff",
                        textDecoration: "none",
                        marginBottom: "0.2rem!important",
                        fontSize: "14px",
                      }}
                    >
                      {" "}
                      <a href="tel:+918700643583" style={{ textDecoration: "none", color: "#fff" }}>Enrolled Student Helpline: +91 8700643583</a>
                    </Typography>
                  </li>
                  <li>
                    <Typography
                      sx={{
                        color: "#fff",
                        textDecoration: "none",
                        marginBottom: "0.2rem!important",
                        fontSize: "14px",
                      }}
                    >
                      {" "}
                      Office Address: 4th Floor, 250, Phase IV, Udyog Vihar,
                      Sector 18, Gurugram, Haryana 122015
                    </Typography>
                  </li>
                </ul>
                {/* <Typography
                  sx={{
                    color: "#fff",
                    textDecoration: "none",
                    marginBottom: "0rem!important",
                    fontSize: "20px",
                    fontWeight: 300,
                  }}
                >
                  Why Accredian
                </Typography> */}
                <ul className="footer-body-content">
                  <li>
                    <Link to="/whyaccredian" style={{ textDecoration: "none" }}>
                      <Typography
                        sx={{
                          color: "#fff",
                          textDecoration: "none",
                          marginBottom: "0rem!important",
                          fontSize: "18px",
                        }}
                      >
                        Why Accredian
                      </Typography>
                    </Link>
                  </li>
                </ul>
                <Typography
                  sx={{
                    color: "#fff",
                    textDecoration: "none",
                    marginBottom: "0.3rem!important",
                    fontSize: "20px",
                    fontWeight: 300,
                  }}
                >
                  Follow Us
                </Typography>
                <a href="https://www.facebook.com/insaidlearn" target="_blank" style={{ textDecoration: "none", color: "#fff" }}><FacebookIcon sx={{ fontSize: "1.7rem" }} /></a>
                <a href="https://www.linkedin.com/school/insaid/" target="_blank" style={{ textDecoration: "none", color: "#fff" }}><LinkedInIcon sx={{ ml: 2, fontSize: "1.7rem" }} /></a>
                <a href="https://twitter.com/insaidlearn" target="_blank" style={{ textDecoration: "none", color: "#fff" }}> <TwitterIcon sx={{ ml: 2, fontSize: "1.7rem" }} /></a>
                <a href="https://www.instagram.com/insaid.learn/" target="_blank" style={{ textDecoration: "none", color: "#fff" }}><InstagramIcon sx={{ ml: 2, fontSize: "1.7rem" }} /></a>
                <a href="https://www.youtube.com/channel/UCE0L_4ADPU2iyKnDJ0xRzyA" target="_blank" style={{ textDecoration: "none", color: "#fff" }}><YouTubeIcon sx={{ ml: 2, fontSize: "1.7rem" }} /></a>
              </div>
            </Grid>

            <Grid item lg={2} sx={{ mt: 4 }}>
              <div className="footer-body-head">
                <Typography
                  sx={{
                    color: "#fff",
                    textDecoration: "none",
                    marginBottom: "0.2rem!important",
                    fontSize: "20px",
                  }}
                >
                  Accredian
                </Typography>
                <ul className="footer-body-content">
                  <li>
                    <Link to="/About" style={{ textDecoration: "none" }}>
                      <Typography
                        sx={{
                          color: "#fff",
                          textDecoration: "none",
                          marginBottom: "0.2rem!important",
                          fontSize: "14px",
                        }}
                      >
                        About
                      </Typography>
                    </Link>
                  </li>
                  <li>
                    <Link to="/Career" style={{ textDecoration: "none" }}>
                      <Typography
                        sx={{
                          color: "#fff",
                          textDecoration: "none",
                          marginBottom: "0.2rem!important",
                          fontSize: "14px",
                        }}
                      >
                        Career
                      </Typography>
                    </Link>
                  </li>
                  <li>
                    <a
                      href="https://blog.accredian.com/"
                      style={{ textDecoration: "none" }}
                    >
                      <Typography
                        sx={{
                          color: "#fff",
                          textDecoration: "none",
                          marginBottom: "0.2rem!important",
                          fontSize: "14px",
                        }}
                      >
                        Blog
                      </Typography>
                    </a>
                  </li>

                  <li>
                    <Link
                      to={"/Policy/admissions-policy"}
                      style={{ textDecoration: "none" }}
                    >
                      <Typography
                        sx={{
                          color: "#fff",
                          textDecoration: "none",
                          marginBottom: "0.2rem!important",
                          fontSize: "14px",
                        }}
                      >
                        Admission Policy
                      </Typography>
                    </Link>
                  </li>
                  <li>
                    <Link
                      to={"/Policy/referral-policy"}
                      style={{ textDecoration: "none" }}
                    >
                      <Typography
                        sx={{
                          color: "#fff",
                          textDecoration: "none",
                          marginBottom: "0.2rem!important",
                          fontSize: "14px",
                        }}
                      >
                        Referral Policy
                      </Typography>
                    </Link>
                  </li>
                  <li>
                    <Link
                      to={"/Policy/privacypolicy"}
                      style={{ textDecoration: "none" }}
                    >
                      <Typography
                        sx={{
                          color: "#fff",
                          textDecoration: "none",
                          marginBottom: "0.2rem!important",
                          fontSize: "14px",
                        }}
                      >
                        Privacy Policy
                      </Typography>
                    </Link>
                  </li>
                  <li>
                    <Link
                      to={"/Policy/terms-of-service"}
                      style={{ textDecoration: "none" }}
                    >
                      <Typography
                        sx={{
                          color: "#fff",
                          textDecoration: "none",
                          marginBottom: "0.2rem!important",
                          fontSize: "14px",
                        }}
                      >
                        Terms Of Service
                      </Typography>
                    </Link>
                  </li>
                  <li>
                    <Link to="/Faq" style={{ textDecoration: "none" }}>
                      <Typography
                        sx={{
                          color: "#fff",
                          textDecoration: "none",
                          marginBottom: "0.2rem!important",
                          fontSize: "14px",
                        }}
                      >
                        Master FAQs
                      </Typography>
                    </Link>
                  </li>
                  {/* <li>
                  <Link to="/Gallery" style={{ textDecoration: "none" }}>
                    <Typography
                      sx={{
                        color: "#fff",
                        textDecoration: "none",
                        marginBottom: "0.2rem!important",
                        fontSize: "14px",
                      }}
                    >
                      Gallery
                    </Typography>
                  </Link>
                </li> */}
                </ul>
              </div>
            </Grid>
          </Grid>
          <Box>
          <Typography
          sx={{
            color: "#fff",
            textAlign: "center",
            py: 5,
            marginBottom: "0rem!important",
            fontSize: "14px",
          }}
        >
          © 2024 Accredian A Brand of FullStack Education Pvt Ltd. All Rights
          Reserved
        </Typography>
          </Box>
        </Container>
      </Box>

      <Box
        sx={{ display: { xs: "block", lg: "none", md: "block", sm: "block" }, backgroundColor: "#000" }}
      >
        {/* <Grid container item lg={12} >
          <Grid item xs={12} sx={{display:"flex", flexDirection:"column"}}>
           <center> 
                <CardMedia
            component="img"
            image="https://www.insaid.co/wp-content/uploads/2021/01/white-logo.png"
            alt="green iguana"
            sx={{ pt:4,width:"180px" }}
          />
            
            </center>
          </Grid>
          <Grid item xs={12} sx={{ py:3}}>
          <center>  <Button variant="contained">
              Schedule 1-on-1 Call Now
            </Button></center>
            
          </Grid>
        </Grid> */}
        <Typography
          sx={{
            color: "#fff",
            textAlign: "center",
            py: 5,
            marginBottom: "0rem!important",
            fontSize: "16px",
          }}
        >
          © 2024 Accredian A Brand of FullStack Education Pvt Ltd. All Rights
          Reserved
        </Typography>
      </Box>
      <Box sx={{ display: "flex", justifyContent: "space-between" }}>
        {/* <Box sx={{ml:3}}> */}
        {/* <FloatingMenu
          style={{ marginRight: "60px" }}
          slideSpeed={100}
          isOpen={isOpen}
          spacing={50}
          // direction={Directions.Right}
          className="menu-btn"
          background="linear-gradient(45deg, #FE6B8B 30%, #FF8E53 90%)"
        >
          <a
            class="mr-2"
            href="https://api.whatsapp.com/send?phone=918287249844&&text=Hi!%20I’d%20like%20to%20chat%20with%20an%20expert"
            target="_blank"
          >
            <img
              src="https://accredian.com/wp-content/uploads/2023/08/whatsapp.png"
              style={{ height: "53px" }}
              alt="whats app logo"
            />
          </a>
        </FloatingMenu> */}

        {/* </Box> */}

        <FloatingMenu
          
          slideSpeed={500}
          isOpen={isOpen}
          spacing={20}
          direction={Directions.Up}
          className="menu-btn"
          background="linear-gradient(45deg, #FE6B8B 30%, #FF8E53 90%)"
          
        >
          <MainButton
          //  style={{paddingBottom:"270px"}}
            isOpen={isOpen}
            iconResting={<ChevronRight />}
            iconActive={<Closeico />}
            background="transparent"
            onClick={() => {
              setIsOpen((prev) => !prev);
            }}
            size={56}
          />

          <ChildButton
            icon={
              <Tooltip title="Live Chat" placement="left-start">
                <ChatBubbleOutlineIcon
                  onClick={handleFreshchatButtonClick}
                  style={{ fontSize: 20, color: "#fff" }}
                />
              </Tooltip>
            }
            background="#007bff"
            size={40}
            style={{ marginbottom: "6px" }}
          ></ChildButton>

          <ChildButton
            icon={
              <Tooltip title="Request Call Back" placement="left-start">
                <CallIcon
                  onClick={handleClickOpenRcb}
                  style={{ fontSize: 20, color: "#fff" }}
                />
              </Tooltip>
            }
            background="#007bff"
            size={40}
          />

        </FloatingMenu>
      </Box>

      <SubFooter />
      <Rcta open={cta} handleClose={RcbhandleClose} />
      {/* {isFreshchatOpen && ( */}
      <FreshChat
        token={process.env.REACT_APP_FRESHCHAT_TOKEN}
        host={"https://insaid.freshchat.com"}
        email="user@email.com"
        // onWidgetClose={()=>{setisFreshchatOpen(false)}}
        config={{
          headerProperty: {
            hideChatButton: true,
            backgroundColor: "#3498db",
            foregroundColor: "#ffffff",
          },
        }}
        externalId={"john.doe1987"} // user’s id unique to your system
        first_name="..."
        onInit={(widget) => {
          // //console.log(888, widget.open());
          // //console.log(111, widget.user.get());
          // //console.log(
          //   333,
          //   widget.on("user:created", function (resp) {
          //     //console.log(11, resp);
          //     var status = resp && resp.status,
          //       data = resp && resp.data;
          //   })
          // );
        }}
        onHide={(widget) => {
          // //console.log(11, widget);
        }}
      />
      {/* )} */}
    </>
  );
};

export default Footer;
